import * as React from "react";
import styled from "styled-components";

import { ButtonStyles } from "src/library/components/Button";
import { IOrderExport } from "src/modules/order-export/api/order-export.api";

interface IDownloadOrderExportProps {
  orderExport: IOrderExport | null;
}

const DownloadOrderExport: React.ReactFCWithChildren<IDownloadOrderExportProps> = ({ orderExport }) => {
  return (
    <>
      {orderExport && (
        <StyledDownloadLink
          href={orderExport.s3BucketUrl}
          download="true"
        >
          Download
        </StyledDownloadLink>
      )}
    </>
  );
};

const StyledDownloadLink = styled.a`
  ${ButtonStyles}
  display: inline-flex;
  text-decoration: none;
`;

export default DownloadOrderExport;
